<template>
  <div v-if="ready">
    <q-card
      class="mdi-card q-ma-md"
      v-if="groupableOptions.length"
    >
      <q-card-main>
      <q-field
        label="Grouped By"
        orientation="vertical"
      >
        <q-select
          v-model="groupedByField"
          :options="groupableOptions"
          @input="fetchData"
          hide-underline
        ></q-select>
      </q-field>
      </q-card-main>
    </q-card>

    <q-card
      v-if="!loading"
        v-for="key in Object.keys(groupedModels)"
        :key="key"
        class="mdi-card q-ma-md"
      >
        <q-card-main>
          <q-collapsible icon="view_list" :label="groupedModels[key][0] | shvl(keyTitlePath || key).toString()" sparse class="uppercase">
            <div>
              <q-list separator no-border link>
                <q-item
                  v-for="row in groupedModels[key]"
                  :key="row.id"
                  :to="{path: `${baseRoute}/edit/${row.id}`}"
                >
                  <q-item-side v-if="imageField">
                    <grid-cell-image :col="imageField" :resource="resource" :value="row[imageField.field]" />
                  </q-item-side>
                  <q-item-main :label="row | shvl(titleFieldPath).toString()" />
                </q-item>
              </q-list>
            </div>
          </q-collapsible>
        </q-card-main>
      </q-card>
  </div>
</template>

<script>
import * as shvl from 'shvl'

export default {
  name: 'LayoutAccordion',
  props: {
    resource: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      groupedModels: [],
      loading: true,
      ready: false
    }
  },
  methods: {
    async fetchData () {
      try {
        this.loading = true
        const { data } = await this.$axios.get(this.apiEndpoint, {
          params: {
            group: this.groupedByField,
            limit: null,
            include: this.$store.state[this.resource].params.include
          }
        })
        this.$set(this, 'groupedModels', data.data)
        this.loading = false
      } catch (e) {
        this.loading = false
        // console.log(e)
      }
    }
  },
  computed: {
    subtitleField () {
      return this.columns.find(col => col.hasOwnProperty('subtitle'))
    },
    selectedOptionColumn () {
      const option = this.groupableOptions.find(o => o.value === this.groupedByField)
      if (option && option.col) {
        return option.col
      }
      return {}
    },
    selectedOptionRelation () {
      if (this.selectedOptionColumn && this.selectedOptionColumn.relation) {
        return this.selectedOptionColumn.relation.namespace
      }
      return null
    },
    apiEndpoint () {
      return this.$store.getters[`${this.resource}/apiEndpoint`](null)
    },
    keyTitlePath () {
      const groupedFieldKey = this.groupedByField
      if (groupedFieldKey) {
        const option = this.groupableOptions.find(opt => opt.value === groupedFieldKey)
        if (option && !!option.col) {
          if (option.col.relation && option.col.relation.label) {
            return `${option.col.field}.${option.col.relation.label}`
          }
          return option.col.field
        }
      }
    },
    subTitleFieldPath () {
      const field = this.subtitleField
      if (field) {
        if (field.relation && field.relation.label) {
          return `${field.field}.${field.relation.label}`
        }
        return field.label || null
      }
      return null
    },
    titleField () {
      return this.columns.find(col => col.isTitle)
    },
    titleFieldPath () {
      const field = this.titleField
      if (field) {
        if (field.relation && field.relation.label) {
          return `${field.field}.${field.relation.label}`
        }
        return field.field
      }
      return null
    },
    baseRoute () {
      return this.$store.state[this.resource].clientRoute
    },
    columns () {
      return this.$store.getters[`${this.resource}/columns`]
    },
    imageField () {
      return this.columns.find(col => col.type && col.type === 'image')
    },
    groupedByField: {
      get () {
        return this.$store.getters[`${this.resource}/groupedByField`]
      },
      set (value) {
        return this.$store.commit(`${this.resource}/SET_SETTING`, {
          field: 'groupedByField',
          value: value
        })
      }
    },
    groupableOptions () {
      return this.columns.filter(col => {
        return col.type !== 'action' && col.field !== 'id' && col.field !== 'createdAt' && col.field !== 'updatedAt' && col.field !== 'name' && col.field !== 'label'
      })
        .map(col => {
          let label = col.label
          let value = col.field
          if (col.relation) {
            label = shvl.get(col, 'label', null)
            if (col.relation.type === 'one') {
              value = `${value}.id`
            }
            if (col.relation.type === 'many') {
              value = col.relation.fk ? `${value}.${col.relation.fk}` : null
            }
          }
          return {
            label: label,
            value: value,
            col: col,
            field: col.field
          }
        })
        .filter(option => option.label !== null && option.value !== null)
    }
  },
  async created () {
    await this.fetchData()
    this.$nextTick(() => {
      this.ready = true
    })
  }
}
</script>

<style>
</style>
